import { FilterOption } from 'src/models/Filter';

export function mapForSingularFilterId(
  categoryId: string,
  map: Map<string, FilterOption>,
): string {
  const filterOption = map.get(categoryId);
  if (filterOption === undefined) {
    return 'default';
  }

  return filterOption.id;
}

export const mapLicenseSelectedValues = (currentValues: string): string[] =>
  currentValues === 'default' || currentValues === ''
    ? []
    : currentValues.split(',');

export function defineSubagentState(map: Map<string, FilterOption>): boolean {
  return (
    mapLicenseSelectedValues(mapForSingularFilterId('subagent', map)).length > 0
  );
}

export const isQueriableSubagent = (
  filterQueryKey: string,
  isAseUser: boolean,
): boolean => {
  if (!isAseUser) {
    return false;
  }
  return (
    filterQueryKey !== '' &&
    filterQueryKey !== 'default' &&
    filterQueryKey.split(',').length === 1
  );
};
